module.exports = __webpack_public_path__ + "media/dashboard/assets/images/notion_app_logo-7aa264a898951e791ee36fd52d8fcd66.png";